export const mutations = {
  UPDATE_CLAIMS (state, payload) {
    state.claims = payload;
  },
  UPDATE_CLAIM (state, payload) {
    // need to update the claim object within the claims array as well as the individual claim
    const claimInClaims = state.claims.find(claim => {
      return claim.ua_icclaimid === payload.ua_icclaimid;
    });

    Object.assign(claimInClaims, payload);

    Object.assign(state.claim, payload);
  },
  RESET_CLAIMS (state) {
    state.claims = [];
    state.claim = {};
  }
};
